import { render, staticRenderFns } from "./LearnGearRatio.vue?vue&type=template&id=7de522b3&scoped=true&"
import script from "./LearnGearRatio.vue?vue&type=script&lang=js&"
export * from "./LearnGearRatio.vue?vue&type=script&lang=js&"
import style0 from "./LearnGearRatio.vue?vue&type=style&index=0&id=7de522b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de522b3",
  null
  
)

export default component.exports